import React from 'react';
import { Row, Col, Layout, Button } from 'antd';
import { Aside, Content as Content1 } from './overview/style';
import Heading from '../../../components/heading/heading';
import './index.css';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { signIn } from '../../../redux/authentication/actionCreator';

function HOCIndex(props) {
                           const { Header } = Layout;
                           const dispatch = useDispatch();
                           const step = useSelector(state => state.auth.step);
                           const stepname = useSelector(state => state.auth.stepname) || '';
                           const isLoading = useSelector(state => state.auth.loading);
                           const dataForm = useSelector(state => state.auth.dataForm);
                           const finalMessage = useSelector(state => state.auth.dataForm.message);
                           const location = useHistory();

                           const handleStep = stepper => {
                             switch (stepper) {
                               case 0:
                                 return (
                                   <img
                                     src={require('../../../static/img/auth/first-signup.svg')}
                                     alt="signup"
                                     className="signup-left"
                                   />
                                 );
                               case 1:
                                 return (
                                   <img
                                     src={require('../../../static/img/auth/first-signup.svg')}
                                     alt="signup"
                                     className="signup-left"
                                   />
                                 );
                               default:
                                 return '';
                             }
                           };

                           const goLogin = () => {
                             let param = {
                               customerType: 'RECRUITER',
                               msisdn: dataForm.phoneNumber || dataForm.msisdn,
                               password: dataForm.password,
                             };

                             // dispatch({type:'RESET_DATA'})
                             dispatch(signIn(param));
                           };

                           const goReload = () => {
                             window.location.href = '/';
                           };

                           const goMain = () => {
                             window.location.href = 'https://kongsiklub.co';
                           };

                           return (
                             <div className="main-div-body">
                               {/* <Header>
        <div onClick={goMain} style={{ float: 'left', position: 'absolute' }}>
          <img
            style={{
              width: '30px',
              height: '30px',
            }}
            src={require('../../../static/img/back.png')}
            alt="back"
          />
        </div>
        <div
          style={{
            width: '100%',
            textAlign: 'center',
          }}
          onClick={goMain}
        >
          <img
            style={{
              width: '93px',
              height: '41px',
            }}
            src={require('../../../static/img/kongsi-logo.png')}
            alt="kongsi-logo"
          />
        </div>
      </Header> */}

                               {step == 6 ? (
                                 <Row>
                                   <div className="main-success">
                                     <img
                                       src={require('../../../static/img/auth/top-img-auth.svg')}
                                       alt=""
                                       className="top"
                                     />
                                     <div className="sub-success">
                                       <img
                                         src={require('../../../static/img/auth/success.svg')}
                                         alt=""
                                         className="middle"
                                       />
                                       <Heading as="h5">{finalMessage ? finalMessage : "Wuhoo, dah jadi geng!"}</Heading>
                                       <Button
                                         className="btn-create"
                                         type="primary"
                                         size="large"
                                         disabled={isLoading}
                                         onClick={goLogin}
                                       >
                                         {isLoading ? 'Loading...' : 'PERGI KE KONGSI-DASH'}
                                       </Button>
                                     </div>
                                     <img
                                       src={require('../../../static/img/auth/bottom-img-auth.svg')}
                                       alt=""
                                       className="bottom"
                                     />
                                     {props.children}
                                   </div>
                                 </Row>
                               ) : stepname == 'forgotPasswordSuccess' ? (
                                 <Row>
                                   <div className="main-success">
                                     <img
                                       src={require('../../../static/img/auth/top-img-auth.svg')}
                                       alt=""
                                       className="top"
                                     />
                                     <div className="sub-success">
                                       <img
                                         src={require('../../../static/img/auth/success-forgotPassword.svg')}
                                         alt=""
                                         className="middle"
                                       />
                                       <Heading as="h5">Kata laluan ditetapkan!</Heading>
                                       <Button
                                         className="btn-create"
                                         type="primary"
                                         size="large"
                                         disabled={isLoading}
                                         onClick={goReload}
                                       >
                                         {isLoading ? 'Loading...' : 'LOG MASUK'}
                                       </Button>
                                     </div>
                                     <img
                                       src={require('../../../static/img/auth/bottom-img-auth.svg')}
                                       alt=""
                                       className="bottom"
                                     />
                                   </div>
                                 </Row>
                               ) : (
                                 <Row>
                                   <Col xxl={16} xl={15} lg={12} md={0} xs={0}>
                                     <Aside>
                                       <div className="auth-side-content">
                                         <div style={{ display: 'flex' }}>
                                           <div
                                             style={{
                                               marginBottom: '5%',
                                               marginLeft: '5%',
                                               marginRight: '2%',
                                               width: '60vw',
                                               marginTop: '12vh',
                                               display: 'flex',
                                               justifyContent: 'flex-start',
                                               alignItems: 'center',
                                             }}
                                           >
                                             <img
                                               style={{
                                                 width: '100%',
                                                 maxWidth: '100%',
                                                 maxHeight: '100%',
                                                 border: '1px solid #EA0029',
                                                 borderRadius: '8px',
                                                 marginTop: '-10%',
                                               }}
                                               src={require(window.location.href.includes('reset-password')
                                                 ? '../../../static/img/auth/password_screen_img.png'
                                                 : window.location.href.includes('signup')
                                                 ? '../../../static/img/auth/login-left2x.png'
                                                 : step == 1
                                                 ? '../../../static/img/auth/login-left2x.png'
                                                 : '../../../static/img/auth/password_screen_img.png')}
                                               alt=""
                                             />
                                           </div>
                                         </div>
                                         <div className="signup-div">
                                           {window.location.href.includes('signup') && handleStep(step)}
                                         </div>
                                       </div>
                                     </Aside>
                                   </Col>

                                   <Col xxl={8} xl={9} lg={12} md={24} xs={24}>
                                     {props.children}
                                   </Col>
                                 </Row>
                               )}
                             </div>
                           );
                         }

export default HOCIndex;
